function cardCounter() {
	var url = window.location.href
	// Вставил url prod tandoor (!!! На локалке не сработает !!!)
	// if (url.indexOf('/catalog/product/') != -1) {
	if (document.querySelector('.Product-description__molding-list') != null) {
		let firstList = document.querySelector('.Product-description__molding-list')
		let firstListItems = firstList.querySelectorAll('.Product-description__molding-item')

		let a = 1

		let finalPrice = document.querySelector('.Product-description__molding-select-total-price')
		let listItem = document.querySelectorAll('.Product-description__molding-item')
		let counterCont = document.querySelector('.Counter__content')
		let buttonCountDec = counterCont.querySelector('button[data-decrement]')
		let buttonCountInc = counterCont.querySelector('button[data-increment]')
		let inputFieldTopCounter = counterCont.querySelector('.Counter__input')
		// let maxNum = counterCont.querySelector('.')
		buttonCountDec.onclick = () => {
			let storage = 0
			listItem[0].setAttribute('data-quantity', listItem[0].getAttribute('data-quantity') / 1 - 1)
			if (listItem[0].getAttribute('data-quantity') / 1 < 1) {
				listItem[0].setAttribute('data-selected', false)
				listItem[0].classList.add('Product-description__molding-item--disabled')
				listItem[0].querySelector('.Checkbox__input').checked = false
				listItem[0].querySelector('.Counter__input').value = 0
				inputFieldTopCounter.value = 0
			} else {
				listItem[0].setAttribute('data-selected', true)
				listItem[0].classList.remove('Product-description__molding-item--disabled')
				listItem[0].querySelector('.Checkbox__input').checked = true


				listItem[0].querySelector('.Counter__input').value = listItem[0].getAttribute('data-quantity')
				document.querySelector('.Counter__block-input').querySelector('.Counter__input').value = listItem[0].getAttribute('data-quantity')
				listItem[0].setAttribute(
					'data-product-summary',
					(listItem[0].querySelector('.Product-description__molding-item-price-text').textContent * listItem[0].querySelector('.Counter__input').value) / 1,
				)
				listItem[0].querySelector('.Product-description__molding-item-price-text-total').textContent = listItem[0].getAttribute('data-product-summary') / 1
				storage += listItem[0].getAttribute('data-product-summary') / 1
				finalPrice.textContent = storage
				document.querySelector('.Product-description__molding-select-total-price').setAttribute('data-final-price', storage)
			}
		}

		inputFieldTopCounter.oninput = () => {
			let storage = 0
			listItem[0].setAttribute('data-quantity', inputFieldTopCounter.value)
			if (listItem[0].getAttribute('data-max') / 1 < inputFieldTopCounter.value) {
				inputFieldTopCounter.value = listItem[0].getAttribute('data-max') / 1

				listItem[0].setAttribute('data-selected', true)
				listItem[0].classList.remove('Product-description__molding-item--disabled')
				listItem[0].querySelector('.Checkbox__input').checked = true

				listItem[0].querySelector('.Counter__input').value = listItem[0].getAttribute('data-max') / 1
				document.querySelector('.Counter__block-input').querySelector('.Counter__input').value = listItem[0].getAttribute('data-max')
				listItem[0].setAttribute(
					'data-product-summary',
					(listItem[0].querySelector('.Product-description__molding-item-price-text').textContent * listItem[0].querySelector('.Counter__input').value) / 1,
				)
				listItem[0].querySelector('.Product-description__molding-item-price-text-total').textContent = listItem[0].getAttribute('data-product-summary') / 1
				storage += listItem[0].getAttribute('data-product-summary') / 1
				finalPrice.textContent = storage
				document.querySelector('.Product-description__molding-select-total-price').setAttribute('data-final-price', storage)
			} else {
				if (inputFieldTopCounter.value > 0) {
					listItem[0].setAttribute('data-selected', true)
					listItem[0].classList.remove('Product-description__molding-item--disabled')
					listItem[0].querySelector('.Checkbox__input').checked = true

					listItem[0].querySelector('.Counter__input').value = listItem[0].getAttribute('data-quantity')
					document.querySelector('.Counter__block-input').querySelector('.Counter__input').value = listItem[0].getAttribute('data-quantity')
					listItem[0].setAttribute(
						'data-product-summary',
						(listItem[0].querySelector('.Product-description__molding-item-price-text').textContent * listItem[0].querySelector('.Counter__input').value) / 1,
					)
					listItem[0].querySelector('.Product-description__molding-item-price-text-total').textContent = listItem[0].getAttribute('data-product-summary') / 1
					storage += listItem[0].getAttribute('data-product-summary') / 1
					finalPrice.textContent = storage
					document.querySelector('.Product-description__molding-select-total-price').setAttribute('data-final-price', storage)
				} else {
					listItem[0].setAttribute('data-selected', false)
					listItem[0].classList.add('Product-description__molding-item--disabled')
					listItem[0].querySelector('.Checkbox__input').checked = false
					listItem[0].querySelector('.Counter__input').value = 0
					inputFieldTopCounter.value = 0
				}
			}
		}

		buttonCountInc.onclick = () => {
			if (listItem[0].getAttribute('data-max') / 1 > inputFieldTopCounter.value) {
				let storage = 0
				listItem[0].setAttribute('data-selected', true)
				listItem[0].classList.remove('Product-description__molding-item--disabled')
				listItem[0].querySelector('.Checkbox__input').checked = true

				listItem[0].setAttribute('data-quantity', listItem[0].getAttribute('data-quantity') / 1 + 1)
				listItem[0].querySelector('.Counter__input').value = listItem[0].getAttribute('data-quantity')
				document.querySelector('.Counter__block-input').querySelector('.Counter__input').value = listItem[0].getAttribute('data-quantity')
				listItem[0].setAttribute(
					'data-product-summary',
					(listItem[0].querySelector('.Product-description__molding-item-price-text').textContent * listItem[0].querySelector('.Counter__input').value) / 1,
				)
				listItem[0].querySelector('.Product-description__molding-item-price-text-total').textContent = listItem[0].getAttribute('data-product-summary') / 1
				storage += listItem[0].getAttribute('data-product-summary') / 1
				finalPrice.textContent = storage
				document.querySelector('.Product-description__molding-select-total-price').setAttribute('data-final-price', storage)
			}
		}

        listItem.forEach((el, id) => {
            let buttonDec = el.querySelector('button[data-decrement]')
            let buttonInc = el.querySelector('button[data-increment]')
            let inputField = el.querySelector('.Counter__input')
            let maxStock
            let maxContent

            const itemStep = el.getAttribute('data-step') ? parseInt(el.getAttribute('data-step')) : 1

            if (el.querySelector('.Product-description__molding-item-stock-num')) {
                maxStock = el.getAttribute('data-max') / 1
                maxContent = el.querySelector('.Product-description__molding-item-stock-num')
                maxContent.textContent = maxStock
            }

            el.classList.add('Product-description__molding-item--disabled')

            document.querySelector('.Product-description__molding-select-total-price').setAttribute('data-final-price', 0)

            el.querySelector('.Checkbox__inner-text').onclick = () => {
                if (el.classList.contains('Product-description__molding-item--disabled')) {
                    el.classList.toggle('Product-description__molding-item--disabled');
                    // ИСПРАВЛЕНО: используем itemStep вместо "1"
                    el.querySelector('.Counter__input').value = itemStep;

                    el.setAttribute('data-quantity', itemStep);
                    el.setAttribute('data-product-summary',
                        (el.querySelector('.Product-description__molding-item-price-text').textContent * itemStep)
                    );
                    el.querySelector('.Product-description__molding-item-price-text-total').textContent =
                        el.getAttribute('data-product-summary');

                } else {
                    el.classList.toggle('Product-description__molding-item--disabled');
                    el.querySelector('.Counter__input').value = "0";

                    el.setAttribute('data-quantity', 0);
                    el.setAttribute('data-product-summary', 0);
                    el.querySelector('.Product-description__molding-item-price-text-total').textContent = "0";
                }

                let storage = 0;
                let storage1 = 0;

                listItem.forEach(item => {
                    storage += parseInt(item.getAttribute('data-product-summary')) || 0;
                });

                firstListItems.forEach(item => {
                    storage1 += parseInt(item.getAttribute('data-quantity')) || 0;
                });

                counterCont.querySelector('.Counter__input').value = storage1;
                finalPrice.textContent = storage;
                document.querySelector('.Product-description__molding-select-total-price')
                    .setAttribute('data-final-price', storage);
            }

            buttonDec.onclick = () => {
                let storage = 0
                let storage1 = 0
                let newValue = (el.querySelector('.Counter__input').value / 1) - itemStep

                if (newValue <= 0) {
                    el.querySelector('.Counter__input').value = 0
                    el.setAttribute('data-product-summary', 0)
                    el.querySelector('.Product-description__molding-item-price-text-total').textContent = 0
                    el.setAttribute('data-quantity', 0)

                    // ДОБАВЛЕНО: пересчет общей суммы
                    listItem.forEach(item => {
                        storage += item.getAttribute('data-product-summary') / 1
                    })
                    firstListItems.forEach(item => {
                        storage1 += item.getAttribute('data-quantity') / 1
                    })
                    counterCont.querySelector('.Counter__input').value = storage1
                    finalPrice.textContent = storage
                    document.querySelector('.Product-description__molding-select-total-price').setAttribute('data-final-price', storage)

                } else {
                    el.querySelector('.Counter__input').value = newValue
                    el.classList.remove('Product-description__molding-item--disabled')
                    el.setAttribute('data-product-summary', (el.querySelector('.Product-description__molding-item-price-text').textContent * el.querySelector('.Counter__input').value) / 1)
                    el.querySelector('.Product-description__molding-item-price-text-total').textContent = el.getAttribute('data-product-summary')
                    el.setAttribute('data-quantity', el.querySelector('.Counter__input').value)
                    listItem.forEach(item => {
                        storage += item.getAttribute('data-product-summary') / 1
                    })
                    firstListItems.forEach(item => {
                        storage1 += item.getAttribute('data-quantity') / 1
                    })
                    counterCont.querySelector('.Counter__input').value = storage1
                    finalPrice.textContent = storage
                    document.querySelector('.Product-description__molding-select-total-price').setAttribute('data-final-price', storage)
                }

                if ((el.querySelector('.Counter__input').value / 1) === 0) {
                    el.classList.add('Product-description__molding-item--disabled')
                    el.setAttribute('data-selected', false)
                    el.querySelector('.Checkbox__input').checked = false
                } else {
                    el.classList.remove('Product-description__molding-item--disabled')
                    el.setAttribute('data-selected', true)
                    el.querySelector('.Checkbox__input').checked = true
                }
            }

            inputField.oninput = () => {
                let storage = 0
                let storage1 = 0
                let inputValue = parseInt(el.querySelector('.Counter__input').value) || 0

                let normalizedValue = Math.round(inputValue / itemStep) * itemStep

                if (normalizedValue < 0) {
                    el.querySelector('.Counter__input').value = 0
                    el.classList.add('Product-description__molding-item--disabled')
                    el.setAttribute('data-selected', false)
                    el.querySelector('.Checkbox__input').checked = false

                } else if (normalizedValue > maxStock) {
                    let maxNormalized = Math.floor(maxStock / itemStep) * itemStep
                    el.querySelector('.Counter__input').value = maxNormalized
                    el.setAttribute('data-product-summary', (el.querySelector('.Product-description__molding-item-price-text').textContent * maxNormalized) / 1)
                    el.querySelector('.Product-description__molding-item-price-text-total').textContent = el.getAttribute('data-product-summary')
                    el.setAttribute('data-quantity', maxNormalized)
                    el.setAttribute('data-selected', true)
                    listItem.forEach(item => {
                        storage += item.getAttribute('data-product-summary') / 1
                    })
                    firstListItems.forEach(item => {
                        storage1 += item.getAttribute('data-quantity') / 1
                    })
                    counterCont.querySelector('.Counter__input').value = storage1
                    finalPrice.textContent = storage
                    document.querySelector('.Product-description__molding-select-total-price').setAttribute('data-final-price', storage)
                    el.classList.remove('Product-description__molding-item--disabled')
                    el.querySelector('.Checkbox__input').checked = true
                } else {
                    el.querySelector('.Counter__input').value = normalizedValue
                    el.setAttribute('data-product-summary', (el.querySelector('.Product-description__molding-item-price-text').textContent * normalizedValue) / 1)
                    el.querySelector('.Product-description__molding-item-price-text-total').textContent = el.getAttribute('data-product-summary')
                    el.setAttribute('data-quantity', normalizedValue)
                    el.setAttribute('data-selected', true)
                    listItem.forEach(item => {
                        storage += item.getAttribute('data-product-summary') / 1
                    })
                    firstListItems.forEach(item => {
                        storage1 += item.getAttribute('data-quantity') / 1
                    })
                    counterCont.querySelector('.Counter__input').value = storage1
                    finalPrice.textContent = storage
                    document.querySelector('.Product-description__molding-select-total-price').setAttribute('data-final-price', storage)
                    el.classList.remove('Product-description__molding-item--disabled')
                    el.querySelector('.Checkbox__input').checked = true
                }
            }

            buttonInc.onclick = () => {
                let newValue = (el.querySelector('.Counter__input').value / 1) + itemStep

                if (newValue <= maxStock) {
                    let storage = 0
                    let storage1 = 0
                    el.querySelector('.Counter__input').value = newValue
                    el.setAttribute('data-product-summary', (el.querySelector('.Product-description__molding-item-price-text').textContent * newValue) / 1)
                    el.querySelector('.Product-description__molding-item-price-text-total').textContent = el.getAttribute('data-product-summary')
                    el.setAttribute('data-quantity', newValue)
                    listItem.forEach(item => {
                        storage += item.getAttribute('data-product-summary') / 1
                    })
                    firstListItems.forEach(item => {
                        storage1 += item.getAttribute('data-quantity') / 1
                    })
                    counterCont.querySelector('.Counter__input').value = storage1
                    finalPrice.textContent = storage
                    document.querySelector('.Product-description__molding-select-total-price').setAttribute('data-final-price', storage)
                    if (newValue > 0) {
                        el.querySelector('.Checkbox__input').checked = true
                        el.setAttribute('data-selected', true)
                        el.classList.remove('Product-description__molding-item--disabled')
                    }
                }
            }

            el.setAttribute('data-price', el.querySelector('.Product-description__molding-item-price-text').textContent)
            el.setAttribute('data-quantity', el.querySelector('.Counter__input').value)
            el.setAttribute('data-product-summary', el.querySelector('.Product-description__molding-item-price-text').textContent * el.querySelector('.Counter__input').value)

            el.querySelector('.Product-description__molding-item-price-text-total').textContent = el.getAttribute('data-product-summary')

            el.setAttribute('data-selected', el.querySelector('.Checkbox__input').checked)

            el.querySelector('.Checkbox__label').addEventListener('click', () => {
                el.setAttribute('data-selected', el.querySelector('.Checkbox__input').checked)
            })
        })
		if (a === 1) {
			listItem[0].querySelector('.Checkbox__inner-text').dispatchEvent(new Event('click'))
			listItem[0].querySelector('.Checkbox__input').checked = true
			listItem[0].setAttribute('data-selected', true)
		}
		a++
		let paletteCounter = counterCont.closest('.Product-description__content-palette-counter')
		if (paletteCounter && !paletteCounter.hasAttribute('data-quantity')) {
			listItem[0].setAttribute('data-selected', false)
			listItem[0].classList.add('Product-description__molding-item--disabled')
			listItem[0].querySelector('.Checkbox__input').checked = false
			listItem[0].querySelector('.Counter__input').value = 0
			listItem[0].setAttribute('data-quantity', 0)
			inputFieldTopCounter.value = 0
		}
	} else if (document.querySelector('.Product-description__content-palette-counter') != null) {
		let parentElem = document.querySelector('.Product-description__content-palette-counter')
		// parentElem.setAttribute('data-quantity', 6)
		let btnDec = parentElem.querySelector('button[data-decrement]')
		let btnInc = parentElem.querySelector('button[data-increment]')
		let input = parentElem.querySelector('.Counter__input')
		let step
		if (parentElem.hasAttribute('data-quantity')) {
			input.value = (parentElem.getAttribute('data-quantity') / 1)
		}
		if (!parentElem.hasAttribute('data-quantity')) {
			input.value = 0
		}
		if (parentElem.getAttribute('data-step') != null && parentElem.getAttribute('data-step') / 1 != 0) {
			step = parentElem.getAttribute('data-step') / 1
		} else {
			step = 1
		}
		btnDec.onclick = () => {
			let num = new Number(input.value)
			if (num != 0) {
				num -= step
				input.value = num
				parentElem.setAttribute('data-quantity', input.value)
			} else {
				num = 0
				input.value = num
			}
		}
		input.oninput = () => {
			if ((input.value / 1) >= 0 && (input.value / 1) <= (input.getAttribute('max') / 1)) {
				parentElem.setAttribute('data-quantity', input.value)
			} else {
				input.value = 0
			}
		}
		btnInc.onclick = () => {
			let num = new Number(input.value)
			num += step
			if (num <= (input.getAttribute('max') / 1)) {
				input.value = num
				parentElem.setAttribute('data-quantity', input.value)
			}
		}
	}
	// } else if (document.querySelector('.Product-description__content-palette-counter') != null) {
	// 	let parentElem = document.querySelector('.Product-description__content-palette-counter')
	// 	let btnDec = parentElem.querySelector('button[data-decrement]')
	// 	let btnInc = parentElem.querySelector('button[data-increment]')
	// 	let input = parentElem.querySelector('.Counter__input')

	// 	const step = 1
	// 	if (parentElem.getAttribute('data-step') != null || parentElem.getAttribute('data-step') / 1 != 0) {
	// 		step = parentElem.getAttribute('data-stpe') / 1
	// 	}

	// 	btnDec.onclick = () => {
	// 		let num = new Number(input.value)
	// 		num -= step
	// 		input.value = num
	// 		parentElem.setAttribute('data-quantity', input.value)
	// 	}
	// 	input.oninput = () => {
	// 		parentElem.setAttribute('data-quantity', input.value)
	// 	}
	// 	btnInc.onclick = () => {
	// 		let num = new Number(input.value)
	// 		num += step
	// 		input.value = num
	// 		parentElem.setAttribute('data-quantity', input.value)
	// 	}
	// }


	if (document.querySelectorAll('.timetable') != null) {
		let list = document.querySelectorAll('.timetable')
		list.forEach(el => {
			list.forEach(item => (item.querySelector('.timetable__item').style.display = 'none'))
			el.addEventListener('click', () => {
				el.querySelector('.timetable__item').style.display === 'block' ? (el.querySelector('.timetable__item').style.display = 'none') : (el.querySelector('.timetable__item').style.display = 'block')
			})
		})
	}

	if (document.querySelectorAll('.inner__input') != null) {
		let img = document.querySelectorAll('.inner__input')
		img.forEach(el => {
			el.addEventListener('change', () => {
				let fileReader = new FileReader()
				fileReader.onload = () => {
					document.querySelector('.img-area').setAttribute('src', fileReader.result)
					document.querySelector('.mg-add-logo__icon').style.opacity = '1'
					document.querySelector('.mg-add-logo__text').style.opacity = '1'
				}
				fileReader.readAsDataURL(el.files[0])
			})
		})
	}
}




function openP() {
    if (document.querySelector('a[href="#popup-check-create"]') != null) {
        let openButton = document.querySelector('a[href="#popup-check-create"]')
        openButton.addEventListener('click', (e) => {
            e.preventDefault(); // Предотвращаем стандартное поведение ссылки

            // Явно вызываем Fancybox
            $.fancybox.open({
                src: '#popup-check-create',
                type: 'inline',
                touch: false
            });

            if (openCounter1 === 1) {
                console.log('Creating QR code');
                new QRCode(document.querySelector('.qr-code'), document.location.href)
                openCounter1--
            }
            newCheck()
        });
    } else {
    }
}

var counter = 1;
var openCounter = 1;
var openCounter1 = 1;

let c = 1;
function newCheck() {
	if (document.querySelector('.popup-check-create')) {
		// Popup window
		let mainEl = document.querySelector('.popup-check-create')
		// Form inputs and etc...
		let blockPag = mainEl.querySelector('.popup-check-create__form-list')
		let inputs = mainEl.querySelectorAll('.Input__inp')
		// Check variablies
		let parentElPopup = document.querySelector('.popup-check-preview')

		let pagonajItem
		let promoItems

		if (!document.querySelector('.popup-check-create--ed')) {
			pagonajItem = blockPag.querySelectorAll('.pagonaj-item')
			promoItems = blockPag.querySelectorAll('.pagonaj-item-promotion')
		}

		let parElementInfo = parentElPopup.querySelector('.check__desc')
		let infoBlock = parElementInfo.querySelector('.check__desc-item')


		if (!document.querySelector('.popup-check-create--ed')) {
			// New code
			let doorPagItem = blockPag.querySelectorAll('[data-door]')
			doorPagItem.forEach(item => {
				let inp = item.querySelector('[type="text"]')
				inp.value = item.getAttribute('data-price-of')
			})

			pagonajItem.forEach((item, id) => {
				let counterInp = item.querySelector('[type="text"]')
				let checkbox = item.querySelector('[type="checkbox"]')
				counterInp.oninput = () => {
					counterInp.value = counterInp.value.replace(/[^0-9]/g, '')
				}
				checkbox.onchange = () => {
					if (!checkbox.checked) {
						promoItems[id].querySelector('[type="checkbox"]').checked = false
						promoItems[id].querySelector('[type="text"]').value = 0
					}
				}
			})


			pagonajItem.forEach((item, id) => {
				promoItems[id].querySelector('.form-list-item__inp').style.height = `${item.clientHeight}px`
			})

			// Promo list JS
			promoItems.forEach((item, id) => {
				let checkbox = item.querySelector('[type="checkbox"]')
				let btnInc = item.querySelector('[data-increment]')
				let counterInp = item.querySelector('[type="text"]')
				let btnDec = item.querySelector('[data-decrement]')

				let step = item.getAttribute('data-step')

				btnInc.onclick = () => {
					let sum = (counterInp.value / 1 + step / 1)
					counterInp.value = sum
					item.setAttribute('data-value-sale', counterInp.value)
				}

				counterInp.oninput = () => {
					counterInp.value = counterInp.value.replace(/[^0-9]/g, '')
					if ((counterInp.value / 1) > (pagonajItem[id].querySelector('[type="text"]').value / 1)) {
						counterInp.value = 0
					}
					item.setAttribute('data-value-sale', counterInp.value)
				}

				btnDec.onclick = () => {
					let sum = (counterInp.value / 1 - step / 1)
					counterInp.value = sum
					item.setAttribute('data-value-sale', counterInp.value)
				}
				const checkboxListner = () => {
					if (!checkbox.checked) {
						checkbox.checked = false
						checkbox.removeAttribute('checked')
						btnInc.setAttribute('disabled', '')
						counterInp.setAttribute('disabled', '')
						btnDec.setAttribute('disabled', '')
						item.removeAttribute('data-value-sale')
					} else {
						checkbox.checked = true
						checkbox.setAttribute('checked', '')
						btnInc.removeAttribute('disabled', '')
						counterInp.removeAttribute('disabled', '')
						btnDec.removeAttribute('disabled', '')
						item.setAttribute('data-value-sale', counterInp.value)
					}
				}
				checkboxListner()
				checkbox.onclick = checkboxListner

				// if sale initially
				if (item.hasAttribute('data-sale')) {
					let sale = item.getAttribute('data-sale')
					counterInp.value = sale
				} else {
					counterInp.value = 0
				}
			})
		}

		let descInfoEl = mainEl.querySelectorAll('.desc-of')


		document.querySelector('.save-pdf').onclick = () => {
			document.querySelector('a[href="#popup-check-preview"]').dispatchEvent(new Event('click'))
			document.body.classList.add('print-check')
			setTimeout(() => { window.print(); document.body.classList.remove('print-check') }, 200)
		}

		if (document.querySelector('.popup-check-create--ed')) {
			let parPopup = document.querySelector('.popup-check-create--ed')
			let price = parPopup.querySelector('[data-price]')
			price.querySelector('[type="text"]').oninput = () => {
				price.querySelector('[type="text"]').value = price.querySelector('[type="text"]').value.replace(/[^0-9]/g, '')
			}

			let checkbox = parPopup.querySelector('[data-promotion]')
			let inp = checkbox.querySelector('[type="text"]')

			inp.oninput = () => {
				inp.value = inp.value.replace(/[^0-9]/g, '')
			}

			checkbox.querySelector('[type="checkbox"]').onchange = () => {
				if (checkbox.querySelector('[type="checkbox"]').checked) {
					inp.removeAttribute('disabled')
				} else {
					inp.setAttribute('disabled', '')
					inp.value = 0
				}
			}

			if (checkbox.hasAttribute('data-value')) {
				checkbox.querySelector('[type="checkbox"]').checked = true
				inp.value = checkbox.getAttribute('data-value')
			}
		}

		document.querySelector('a[href="#popup-check-preview"]').onclick = (e) => {
			// Закрытие popup'a
			document.querySelector('.fancybox-close-small').onclick = () => {
				e.preventDefault()
				$.fancybox.close()
			}

			if (!document.querySelector('.popup-check-create--ed')) {
				// New code
				let pagItem = blockPag.querySelectorAll('[data-door]')
				pagItem.forEach((pag, id) => {
					let inp = pag.querySelector('[type="text"]')
					let name = pag.getAttribute('data-door-type')
					if (c > 0) {
						let parEl = parentElPopup.querySelector('.check__item--two')
						let cloneEl = parEl.querySelector('.check__total-price').cloneNode(true)
						cloneEl.querySelector('.name-of-door').textContent = name
						cloneEl.querySelector('.total-price-of').innerHTML = inp.value + ' ₽'
						cloneEl.removeAttribute('style')
						parEl.appendChild(cloneEl)
					} else {
						let parEl = parentElPopup.querySelector('.check__item--two')
						let price = parEl.querySelectorAll('.check__total-price:not([style])')

						let field = price[id].querySelector('span')
						field.textContent = inp.value + ' ₽'
					}
				})

				if (c > 0) {
					document.querySelectorAll('.total-price-of--promotion-item')[0].classList.remove('total-price-of--promotion-item')
				}
				c--



				let newPrice = document.querySelectorAll('.total-price-of--promotion-item')

				let promoDoor = document.querySelectorAll('[data-door-sale]')
				promoDoor.forEach((promo, promoId) => {
					let to = parentElPopup.querySelector('.check__typeof')
					if (promo.querySelector('[type="checkbox"]').checked) {
						to.classList.add('check__typeof--active')
						if (newPrice[promoId].hasAttribute('style')) newPrice[promoId].removeAttribute('style')
						let oldPrice
						if (promoDoor.length === 1) {
							oldPrice = document.querySelectorAll('.total-price-of')[promoId + 1]
						} else if (promoDoor.length === 2) {
							oldPrice = document.querySelectorAll('.total-price-of')[promoId + 1]
						}
						let oldSum = oldPrice.textContent
						oldPrice.setAttribute('style', 'margin-top: -13px; margin-bottom: -7px;')
						newPrice[promoId].innerHTML = promo.getAttribute('data-value-sale') + " ₽"
						let finalSale = 100 - ((promo.getAttribute('data-value-sale') / 1) / (pagItem[promoId].querySelector('[type="text"]').value / 1) * 100)
						oldPrice.innerHTML = "<span class='oldPrice'>" + `-${finalSale.toFixed(0)}% <span style="color: #8F96B0; font-weight: 400;">/</span> ` + "</span>" + "<span class='newPrice'>" + oldSum + "</span>"
						oldPrice.querySelector('.oldPrice').setAttribute('style', 'text-decoration: none; color: #9ACA3C; font-size: 20px')
						oldPrice.querySelector('.newPrice').setAttribute('style', 'color: #8F96B0; text-decoration: line-through; font-size: 16px; font-weight: 400;')
					} else {
						newPrice[promoId].setAttribute('style', 'display: none;')
						let oldPrice
						if (promoDoor.length === 1) {
							oldPrice = document.querySelectorAll('.total-price-of')[promoId + 1]
						} else if (promoDoor.length === 2) {
							oldPrice = document.querySelectorAll('.total-price-of')[promoId + 1]
						}
						oldPrice.removeAttribute('style')
						// oldPrice.querySelector('.oldPrice').removeAttribute('style')
					}
					if (promoDoor.length === 2) {
						if (!promoDoor[0].querySelector('[type="checkbox"]').checked && !promoDoor[1].querySelector('[type="checkbox"]').checked) {
							to.classList.remove('check__typeof--active')
						}
					} else if (promoDoor.length === 1) {
						if (promoDoor.length === 1 && !promoDoor[0].querySelector('[type="checkbox"]').checked) {
							to.classList.remove('check__typeof--active')
						}
					}
				})
			}

			descInfoEl.forEach((el, id) => {
				if (openCounter > 0) {
					if (document.querySelector('.popup-check-create--ed')) {
						if (id < descInfoEl.length - 1) {
							let cloneEl = infoBlock.cloneNode(true)
							cloneEl.querySelector('.desc-of').textContent = el.value
							cloneEl.querySelector('.desc-item__char').textContent = el.closest('label').querySelector('.Input__label-text').textContent + ':'
							cloneEl.removeAttribute('style')
							parElementInfo.appendChild(cloneEl)
						}
					} else {
						let cloneEl = infoBlock.cloneNode(true)
						cloneEl.querySelector('.desc-of').textContent = el.value
						cloneEl.querySelector('.desc-item__char').textContent = el.closest('label').querySelector('.Input__label-text').textContent + ':'
						cloneEl.removeAttribute('style')
						parElementInfo.appendChild(cloneEl)
					}
				}
			})
			openCounter--

			if (!document.querySelector('.popup-check-create--ed')) {
				console.log(123)
				let promoApp = document.querySelectorAll('.pagonaj-item-promotion:not([data-door-sale])')
				let pogonajApp = document.querySelectorAll('.pagonaj-item:not([data-door-type])')
				let parEl = document.querySelector('.check__detail-price')
				let elemPriceOfApp = parEl.querySelectorAll('.check__detail-price__item')
				promoApp.forEach((promo, id) => {
					if (promo.querySelector('[type="checkbox"]').checked && pogonajApp[id].querySelector('[type="checkbox"]').checked) {
						console.log(123333)
						let price
						if (document.querySelectorAll('[data-door-type]').length === 2) {
							price = elemPriceOfApp[id + 2].querySelector('.detail-price-of')
							console.log(123)
						} else if (document.querySelectorAll('[data-door-type]').length === 1) {
							price = elemPriceOfApp[id + 1].querySelector('.detail-price-of')
							console.log(321)
						}
						price.innerHTML = "<span class='oldPrice'>" + pogonajApp[id].querySelector('[type="text"]').value + " ₽" + "</span>" +
							"<span class='newPrice'>" + promo.querySelector('[type="text"]').value + " ₽" + "</span>"
						price.querySelector('.oldPrice').setAttribute('style', 'text-decoration: line-through; margin-right: 10px; color: #8F96B0;')
					} else {
						let price 
						if (document.querySelectorAll('[data-door-type]').length === 2) {
							price = elemPriceOfApp[id + 2].querySelector('.detail-price-of')
							console.log(123)
						} else if (document.querySelectorAll('[data-door-type]').length === 1) {
							price = elemPriceOfApp[id + 1].querySelector('.detail-price-of')
							console.log(321)
						}
						price.innerHTML = "<span class='oldPrice'>" + pogonajApp[id].querySelector('[type="text"]').value + " ₽" + "</span>"
					}
				})
			}

			blockPag.querySelectorAll('.pagonaj-item').forEach(el => {
				// Events
				inputs.forEach((el, id) => {
					parentElPopup.querySelectorAll('.name-of').forEach(item => {
						inputs.forEach(el => {
							if (el.classList.contains('name-of')) {
								item.textContent = el.value
							}
						})
					})
				})
				if (!document.querySelector('.popup-check-create--ed')) {
					parentElPopup.querySelectorAll('.check__detail-price__item').forEach((item, index) => {
						try {
							if (blockPag.querySelectorAll('.pagonaj-item')[index].querySelector('.mg-checkbox__input').hasAttribute('checked') && !blockPag.querySelectorAll('.pagonaj-item')[index].hasAttribute('data-door')) {
								item.querySelector('.detail-name-of').textContent = blockPag.querySelectorAll('.pagonaj-item')[index].querySelector('.mg-avatar__link').textContent + ' (1 шт)'
								item.style.display = 'flex'
							} else {
								item.style.display = 'none'
							}
						} catch (error) {

						}

					})
				}
			})

			if (!document.querySelector('.popup-check-create--ed')) {
				blockPag.querySelectorAll('.pagonaj-item').forEach((el, index) => {
					try {
						if (el.querySelector('.mg-checkbox__input').hasAttribute('checked')) {
							let totalprice = 0
							el.setAttribute('data-price-of', el.getAttribute('data-price') * priceCounter + el.getAttribute('data-price-of') / 1)
							el.querySelector('.Counter__input').value = el.getAttribute('data-price-of')
							parentElPopup.querySelectorAll('.check__detail-price__item')[index].querySelector('.detail-price-of').textContent = el.getAttribute('data-price-of') + ' ₽'
							blockPag.querySelectorAll('.Counter__input').forEach((el, i) => {
								if (el.closest('li').classList.contains('checked-item')) {
									totalprice += el.value / 1
								}
							})
							blockPag.setAttribute('total-price-of', totalprice)
							priceCounter++
						}
					} catch (error) {

					}
				})
			}

			if (document.querySelector('.popup-check-create--ed')) {
				let parPopup = document.querySelector('.popup-check-create--ed')
				let price = parPopup.querySelector('[data-price]')
				let previewPrice = parentElPopup.querySelector('.check__total-price')

				document.querySelectorAll('.check__item')[2].setAttribute('style', 'padding-top: 30px; padding-bottom: 30px;')

				let mainName = parentElPopup.querySelector('.name-of')
				let to = parentElPopup.querySelector('.check__typeof')
				let checkbox = parPopup.querySelector('[data-promotion]')

				previewPrice.removeAttribute('style')
				let oldPrice = previewPrice.querySelector('.total-price-of')
				let newPrice = previewPrice.querySelector('.total-price-of--promotion-item')
				let name = previewPrice.querySelector('.name-of-door')

				let createName = parPopup.querySelector('[data-name-of]')
				mainName.textContent = createName.querySelector('[type="text"]').value
				oldPrice.textContent = price.querySelector('[type="text"]').value + " ₽"

				if (checkbox.querySelector('[type="checkbox"]').checked) {
					newPrice.removeAttribute('style')
					let oldSum = oldPrice.textContent
					newPrice.innerHTML = checkbox.querySelector('[type="text"]').value + " ₽"
					newPrice.setAttribute('style', 'margin-bottom: 5px;')
					let finalSale = 100 - ((checkbox.querySelector('[type="text"]').value / 1) / (price.querySelector('[type="text"]').value / 1) * 100)
					oldPrice.innerHTML = "<span class='oldPrice'>" + `-${finalSale.toFixed(0)}% <span style="color: #8F96B0; font-weight: 400;">/</span>` + "</span>" + "<span class='newPrice'>" + oldSum + "</span>"
					oldPrice.querySelector('.oldPrice').setAttribute('style', 'text-decoration: none; color: #9ACA3C; font-size: 20px')
					oldPrice.setAttribute('style', 'margin-bottom: -7px;')
					oldPrice.querySelector('.newPrice').setAttribute('style', 'color: #8F96B0; text-decoration: line-through; font-size: 16px; font-weight: 400;')
					name.setAttribute('style', 'display: none;')
				} else {
					oldPrice.removeAttribute('style')
					newPrice.setAttribute('style', 'display: none;')
				}

				if (checkbox.querySelector('[type="checkbox"]').checked) {
					to.classList.add('check__typeof--active')
				} else {
					to.classList.remove('check__typeof--active')
				}
			}

			// if (!e.isTrusted) setTimeout(() => {$.fancybox.close()}, 500)
		}

		if (!document.querySelector('.popup-check-create--ed')) {
			blockPag.querySelectorAll('.pagonaj-item').forEach((el, index) => {
				let priceCounter = 1
				el.querySelector('.Counter__input').value = el.getAttribute('data-price-of')

				if (counter === 1) {
					el.querySelector('button[data-decrement]').onclick = () => {
						if (el.querySelector('.mg-checkbox__input').hasAttribute('checked')) {
							if (el.getAttribute('data-price-of') <= 0) {
								el.setAttribute('data-price-of', 0)
							} else {
								let totalprice = 0
								el.setAttribute('data-price-of', el.getAttribute('data-price-of') - el.getAttribute('data-price'))
								el.querySelector('.Counter__input').value = el.getAttribute('data-price-of')
								parentElPopup.querySelectorAll('.check__detail-price__item')[index].querySelector('.detail-price-of').textContent = el.getAttribute('data-price-of') + ' ₽'
								blockPag.querySelectorAll('.Counter__input').forEach((el, i) => {
									if (el.closest('li').classList.contains('checked-item')) {
										totalprice += el.value / 1
									}
								})
								blockPag.setAttribute('total-price-of', totalprice)
								parentElPopup.querySelector('.total-price-of').textContent = blockPag.getAttribute('total-price-of') + '₽'
								priceCounter--
							}
						}
					}
					el.querySelector('button[data-increment]').onclick = () => {
						if (el.querySelector('.mg-checkbox__input').hasAttribute('checked')) {
							let totalprice = 0
							el.setAttribute('data-price-of', (el.getAttribute('data-price-of') / 1 + el.getAttribute('data-price') / 1))
							el.querySelector('.Counter__input').value = el.getAttribute('data-price-of')
							parentElPopup.querySelectorAll('.check__detail-price__item')[index].querySelector('.detail-price-of').textContent = el.getAttribute('data-price-of') + ' ₽'
							blockPag.querySelectorAll('.Counter__input').forEach((el, i) => {
								if (el.closest('li').classList.contains('checked-item')) {
									totalprice += el.value / 1
								}
							})
							blockPag.setAttribute('total-price-of', totalprice)
							parentElPopup.querySelector('.total-price-of').textContent = blockPag.getAttribute('total-price-of') + ' ₽'
							priceCounter++
						}
					}

					el.querySelector('.Counter__input').onchange = () => {
						if (el.querySelector('.mg-checkbox__input').hasAttribute('checked')) {
							let totalprice = 0
							el.setAttribute('data-price-of', el.querySelector('.Counter__input').value)
							parentElPopup.querySelectorAll('.check__detail-price__item')[index].querySelector('.detail-price-of').textContent = el.getAttribute('data-price-of') + '₽'
							blockPag.querySelectorAll('.Counter__input').forEach((el, i) => {
								if (el.closest('li').classList.contains('checked-item')) {
									totalprice += el.value / 1
								}
							})
							blockPag.setAttribute('total-price-of', totalprice)
							parentElPopup.querySelector('.total-price-of').textContent = blockPag.getAttribute('total-price-of') + ' ₽'
						}
					}

					el.querySelector('.mg-checkbox__input').onclick = () => {
						if (el.querySelector('.mg-checkbox__input').hasAttribute('checked')) {
							el.querySelector('.mg-checkbox__input').removeAttribute('checked')
							el.classList.remove('checked-item')
							el.querySelector('.Counter__input').setAttribute('disabled', '')

						} else {
							el.querySelector('.mg-checkbox__input').setAttribute('checked', '')
							el.querySelector('.Counter__input').removeAttribute('disabled')
							el.classList.add('checked-item')
						}

						let totalprice = 0
						parentElPopup.querySelectorAll('.check__detail-price__item')[index].querySelector('.detail-price-of').textContent = el.getAttribute('data-price-of') + ' ₽'
						blockPag.querySelectorAll('.Counter__input').forEach((el, i) => {
							if (el.closest('li').classList.contains('checked-item')) {
								totalprice += el.value / 1
							}
						})
						blockPag.setAttribute('total-price-of', totalprice)
						parentElPopup.querySelector('.total-price-of').textContent = blockPag.getAttribute('total-price-of') + ' ₽'
						priceCounter++

						blockPag.querySelectorAll('.pagonaj-item').forEach(el => {
							// Events

							parentElPopup.querySelectorAll('.check__detail-price__item').forEach((item, index) => {
								try {
									if (blockPag.querySelectorAll('.pagonaj-item')[index].querySelector('.mg-checkbox__input').hasAttribute('checked')) {
										// item.querySelector('.detail-name-of').textContent = el.querySelector('.mg-avatar__link').textContent
										item.style.display = 'flex'
									}
								} catch (error) {

								}
							})
						})
					}
				}
			})
		}
		document.querySelector('.print-pdf').onclick = () => {
			document.querySelector('a[href="#popup-check-preview"]').dispatchEvent(new Event('click'))
			document.body.classList.add('print-check')
			setTimeout(() => { window.print(); document.body.classList.remove('print-check') }, 200)
		}
	}
}